import type { MouseEvent } from 'react'

/**
 * True if the click makes the browser open the link in a new tab/window
 * (Cmd/Ctrl/Shift + click), so the page we are on should stay as it is.
 */
export function opensInNewTab(event: MouseEvent): boolean {
  return event.metaKey || event.ctrlKey || event.shiftKey
}
